"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicUserProperties = void 0;
var PublicUserProperties;
(function (PublicUserProperties) {
    PublicUserProperties["id"] = "id";
    PublicUserProperties["username"] = "username";
    PublicUserProperties["createdAt"] = "createdAt";
    PublicUserProperties["avatarUrl"] = "avatarUrl";
    PublicUserProperties["displayName"] = "displayName";
    PublicUserProperties["bio"] = "bio";
    PublicUserProperties["badges"] = "badges";
    PublicUserProperties["registeredWithUrbit"] = "registeredWithUrbit";
    PublicUserProperties["generatedKey"] = "generatedKey";
    PublicUserProperties["verifiedKey"] = "verifiedKey";
    PublicUserProperties["inviteId"] = "inviteId";
})(PublicUserProperties = exports.PublicUserProperties || (exports.PublicUserProperties = {}));
//# sourceMappingURL=user.entity.js.map